import React from "react";
import "./Home.css";
import Houl from "../images/houl.png";
import debouncingBlog from "../images/debouncing_blog.png";
import substack from "../images/substack_thumbnail.jpg";
import substack2 from "../images/substack_blog_2.jpg";
import Frittr from "../images/frittr.png";
import Videa from "../images/videa.png";
import Dyme from "../images/dyme.png";
import { Helmet } from "react-helmet";
import NavTab from "./NavTab";
import Footer from "./Footer";
import { Link } from "react-router-dom";
// React Slick Carousel Dependencies
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Home() {
  // Carousel items data
  const carouselItems = [
    {
      image: Houl,
      title: "Houl",
      description:
        "The Ultimate creator-centred Live Streaming platform optimized for effortless monetization.",
      link: "https://houl.tech/",
    },
    {
      image: Dyme,
      title: "Dyme",
      description:
        "Social Media app which makes you money based on your content.",
      link: "https://dymesocial.com/",
    },
    {
      image: substack,
      title:
        "The Rise of Aggregator Businesses: A Revolutionary Yet Costly Innovation",
      description:
        "World is in desperate need of lean or no-commissions model.",
      link: "https://prashantscripts.substack.com/p/the-rise-of-aggregator-businesses",
    },
    {
      image: substack2,
      title: "What I Learned About Founders by Being One Who Failed Fast",
      description:
        "Failing fast isn't just about the product—it's about the founder figuring out if they're the one meant to build it in the first place.",
      link: "https://open.substack.com/pub/prashantscripts/p/what-i-learned-about-founders-by?r=ljsbj&utm_campaign=post&utm_medium=web&showWelcomeOnShare=true",
    },
    {
      image: debouncingBlog,
      title: "Debouncing & Throttling in Javascript",
      description: "What are they and how do we optimise our web applications?",
      link: "https://prashantxwrites.hashnode.dev/debouncing-and-throttling-in-javascript",
    },
  ];

  // React Slick Carousel settings
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  };

  return (
    <div>
      <Helmet>
        <title>Prashant Singh Chauhan</title>
      </Helmet>
      <NavTab />

      {/* Intro Section */}
      <div className="introParent">
        <div className="text">
          <h1>Hi there!</h1>
          <h2>I'm Prashant,</h2>
          <span>
            {" "}
            2x founder with
            <span style={{ color: "black" }}>
              {" "}
              <span style={{ color: "#1C9C76" }}>
                deep 0→1 experience,technical edge, and a conviction-led
                approach
              </span>{" "}
              to{" "}
            </span>{" "}
            finding exceptional people and ideas.
          </span>

          <p>
            Passionate about creator economy, lean monetization, and backing
            high-agency talent before the market sees them.
          </p>
          <p style={{ fontWeight: 500 }}>
            Your go-to innovator, problem-solver, and creator advocate! 🚀
          </p>
        </div>

        {/* Carousel Section */}

        <div className="carousel">
          <Slider {...sliderSettings}>
            {carouselItems.map((item, index) => (
              <div key={index} className="carouselItem">
                <img
                  src={item.image}
                  alt={item.title}
                  className="carouselImage"
                />

                <h3>{item.title}</h3>
                <p>{item.description}</p>
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="carouselLink"
                >
                  Visit
                </a>
              </div>
            ))}
          </Slider>
        </div>
      </div>
      {/* Blogs Section */}
      <div className="project">
        <h2>
          Fresh <span>Blogs 🍃</span>
        </h2>

        <div className="cardParent">
          {" "}
          <div className="card">
            <h3>What I Learned About Founders by Being One Who Failed Fast</h3>
            <small>17th May 2025</small>
            <div className="proj-preview">
              <img
                src={substack2}
                alt="Failing fast isn't just about the product—it's about the founder figuring out if they're the one meant to build it in the first place."
              />
            </div>
            <p>
              Failing fast isn't just about the product—it's about the founder
              figuring out if they're the one meant to build it in the first
              place.
            </p>

            <div className="code">
              <a
                href="https://open.substack.com/pub/prashantscripts/p/what-i-learned-about-founders-by?r=ljsbj&utm_campaign=post&utm_medium=web&showWelcomeOnShare=true"
                target="_blank"
                rel="noreferrer noopener"
                className="live"
                style={{ padding: "0.25rem 1.5rem" }}
              >
                <strong>Read</strong>
              </a>
            </div>
          </div>
          <div className="card">
            <h3>Debouncing & Throttling in Javascript</h3>
            <small>21st Jan 2025</small>
            <div className="proj-preview">
              <img
                src={substack}
                alt="The Rise of Aggregator Businesses: A Revolutionary Yet Costly Innovation"
              />
            </div>
            <p>World is in desperate need of lean or no-commissions model.</p>

            <div className="code">
              <a
                href="https://prashantscripts.substack.com/p/the-rise-of-aggregator-businesses"
                target="_blank"
                rel="noreferrer noopener"
                className="live"
                style={{ padding: "0.25rem 1.5rem" }}
              >
                <strong>Read</strong>
              </a>
            </div>
          </div>
          <div className="card">
            <h3>Debouncing & Throttling in Javascript</h3>
            <small>6th June 2022</small>
            <div className="proj-preview">
              <img
                src={debouncingBlog}
                alt="Debouncing & Throttling in Javascript"
              />
            </div>
            <p>
              What are they and how do we use them to implement optimization in
              our web applications?
            </p>

            <div className="code">
              <a
                href="https://prashantxwrites.hashnode.dev/debouncing-and-throttling-in-javascript"
                target="_blank"
                rel="noreferrer noopener"
                className="live"
                style={{ padding: "0.25rem 1.5rem" }}
              >
                <strong>Read</strong>
              </a>
            </div>
          </div>
        </div>
        <Link exact to="/blogs" className="viewA">
          View All
        </Link>
      </div>
      {/* Projects Section */}
      <div className="project">
        <h2>
          Hot <span>Projects 🔥</span>
        </h2>
        <div className="cardParent">
          <div className="card">
            <h3>Videa</h3>
            <small>15th March 2025</small>
            <div className="proj-preview">
              <img src={Videa} alt="Videa" />
            </div>
            <p>
              AI-powered content ideation engine for content creators with
              realtime trends across platforms.
            </p>
            <div className="techStack">
              <h6>Next.js</h6>
              <h6>gpt-4</h6>
              <h6>Tailwind CSS</h6>
            </div>
            <div className="code">
              <a
                href="https://v1dea.vercel.app"
                target="_blank"
                rel="noreferrer noopener"
                className="live"
              >
                View Live
              </a>
              <a
                href="https://github.com/percius47/Videa"
                target="_blank"
                rel="noreferrer noopener"
                className="source"
              >
                View Source
              </a>
            </div>
          </div>

          {/* Houl */}
          <div className="card">
            <h3>Houl</h3>
            <small>11th Jul 2024</small>
            <div className="proj-preview">
              <img src={Houl} alt="Houl" />
            </div>
            <p>Live Streaming platform optimized for instant, effortless monetization.</p>
            <div className="techStack">
              <h6>AWS IVS</h6>
              <h6>Next.js</h6>
              <h6>Tailwind CSS</h6>
            </div>
            <div className="code">
              <a
                href="https://houl.live/"
                target="_blank"
                rel="noreferrer noopener"
                className="live"
              >
                View Live
              </a>
              <a
                href="https://github.com/percius47/HOUL-main"
                target="_blank"
                rel="noreferrer noopener"
                className="source"
              >
                View Source
              </a>
            </div>
          </div>
          {/* Dyme */}
          <div className="card">
            <h3>Dyme</h3>
            <small>10th March 2024</small>
            <div className="proj-preview">
              <img src={Dyme} alt="Dyme" />
            </div>
            <p>Social Media app which makes you money based on your content.</p>
            <div className="techStack">
              <h6>Firebase</h6>
              <h6>Chakra UI</h6>
              <h6>MERN</h6>
            </div>
            <div className="code">
              <a
                href="https://dymesocial.com/"
                target="_blank"
                rel="noreferrer noopener"
                className="live"
                style={{ padding: "0.25rem 1.5rem" }}
              >
                <strong> Join Dyme</strong>
              </a>
              <a
                href="https://github.com/percius47/dyme_firebase"
                target="_blank"
                rel="noreferrer noopener"
                className="source"
              >
                View Source
              </a>
            </div>
          </div>
        </div>
        <Link exact to="/projects" className="viewA">
          View All
        </Link>
      </div>

      {/* <Skills /> */}
      <Footer />
    </div>
  );
}

export default Home;
